import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { CommanderThunkDispatch, WithCompanyId } from '@mews-commander/types';
import { useCurrentEnterpriseId } from '@mews-commander/core';
import { AccountBilling } from '../../../../billing/AccountBilling/AccountBilling';
import { initializeAccountBilling } from '../../../../billing/actions/billing';

export const BillingTab = ({ companyId }: WithCompanyId) => {
    const dispatch: CommanderThunkDispatch = useDispatch();
    const enterpriseId = useCurrentEnterpriseId();

    useEffect(() => {
        dispatch(initializeAccountBilling({ accountId: companyId, scope: companyId }));
    }, [companyId, dispatch]);

    return (
        <div>
            <AccountBilling accountId={companyId} scope={companyId} enterpriseId={enterpriseId} />
        </div>
    );
};
